<template>
  <div :class="['app-header', addClass ? 'headerColor' : '']">
    <div class="back_logo" @click="$router.go(-1)">
      <svg-icon v-if="!leftHide" name="chevron-left" />
    </div>

    <div class="header-title">
      {{ $t(`${title}`) }}
    </div>
    <div />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'Header',
  props: {
    title: {
      type: String,
      default: ''
    },
    leftHide: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      addClass: state => state.addClass
    })
  },
  watch: {
    $route: {
      handler (to, from) {
        if (to.meta.class) {
          this.change_addClass(true)
        } else {
          this.change_addClass(false)
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapMutations(['change_addClass'])
  }
}
</script>

<style lang="scss" scoped>
/* stylelint-disable  declaration-block-no-duplicate-properties */
.app-header {
  height: 88px;
  width: 100%;
  font-size: 36px;
  background: #fff;
  display: flex;
  align-items: center;
  transform: translate3d(0, 0, 0); // HACK 分层优化
  padding-top: 10px;

  .header-title {
    display: flex;
    flex: 1;
    justify-content: center;
    font-weight: 500;
    color: #242424;
  }

  .back_logo {
    position: relative;
    left: 16px;
  }
}

.headerColor {
  background: #ffea33;
}
/* stylelint-enable */
</style>
